import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserV2 } from '@vi-iot/client';
import { Observable } from 'rxjs';

import { GatewayInvitationsActions } from './gateway-invitations.actions';
import { CompanyDetails, SearchParams } from './gateway-invitations.model';
import { GatewayInvitationsSelectors } from './gateway-invitations.selectors';

@Injectable({ providedIn: 'root' })
export class GatewayInvitationsStore {
  state$ = this.store.select(GatewayInvitationsSelectors.getState());

  constructor(private store: Store) {}

  listGatewayInvitations(params: SearchParams): void {
    this.store.dispatch(GatewayInvitationsActions.listGatewayInvitations(params));
  }

  filterByStatus(params: SearchParams): void {
    this.store.dispatch(GatewayInvitationsActions.filterByStatus(params));
  }

  clearStore(): void {
    this.store.dispatch(GatewayInvitationsActions.clearStore());
  }

  selectInviterDetails(account: string): Observable<UserV2> {
    return this.store.select(GatewayInvitationsSelectors.selectInviterDetails(account));
  }

  selectInviteeDetails(account: string): Observable<UserV2> {
    return this.store.select(GatewayInvitationsSelectors.selectInviteeDetails(account));
  }

  selectInviteeCompanyDetails(customerNumber: string): Observable<CompanyDetails> {
    return this.store.select(
      GatewayInvitationsSelectors.selectInviteeCompanyDetails(customerNumber)
    );
  }

  selectInviterCompanyDetails(customerNumber: string): Observable<CompanyDetails> {
    return this.store.select(
      GatewayInvitationsSelectors.selectInviterCompanyDetails(customerNumber)
    );
  }
}
